//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    getRuns(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.admin.runs).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getRun(vue, runIdentifier, cb, errorCb, finallyCb) {
        // should be GET but ...
        axios.post(window.kgkRoutes.admin.run, { identifier: runIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    invalidateRun(vue, runIdentifier, message, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.admin.invalidate, {
            identifier: runIdentifier,
            message: message,
        }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    downloadExportUsers(vue, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.admin.exportUsers, {}, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getRoutesFromServer(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.configuration.routes).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getConfigFromServer(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.configuration.config).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getMenuFromServer(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.configuration.getMenu).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getCompaniesFromServer(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.admin.companies).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getTextsFromServer(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.admin.getTexts).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    postTextsToServer(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.admin.postTexts, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

}
